module.exports = __webpack_public_path__ + "img/footer_logo.672daa6a.png";